document.addEventListener('DOMContentLoaded', function () {
  // Featured product variant selection handling
  const variantSelects = document.querySelectorAll('.featured-variant-select');
  const priceElements = document.querySelectorAll('.featured-product-price');
  const imageElement = document.getElementById('featured-variant-image');
  const buyNowButtons = document.querySelectorAll('.featured-buy-now-btn');

  // Handle variant changes
  variantSelects.forEach(function(variantSelect, index) {
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];

        const price = selectedOption.getAttribute('data-price');
        const image = selectedOption.getAttribute('data-image');
        const variantId = selectedOption.value;

        // Update price if element exists
        if (priceElements[index]) {
          priceElements[index].textContent = `${price} kr`;
        }

        // Update image if exists
        if (image && imageElement) {
          imageElement.setAttribute('src', image);
        }

        // Update buy now button variant ID
        buyNowButtons.forEach(function(button) {
          button.setAttribute('data-variant-id', variantId);
        });

        // Update dynamic payment buttons variant ID
        const paymentVariantInputs = document.querySelectorAll('.featured-payment-variant-id');
        paymentVariantInputs.forEach(function(input) {
          input.value = variantId;
        });
      });
    }
  });

  // Handle quantity decrease
  const decreaseButtons = document.querySelectorAll('.featured-quantity-decrease');
  decreaseButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const quantityId = this.getAttribute('data-quantity-id');
      const input = document.getElementById(quantityId);
      if (input) {
        let quantity = parseInt(input.value, 10);
        if (quantity > 1) {
          input.value = quantity - 1;
          
          // Update dynamic payment buttons quantity
          const paymentQuantityInputs = document.querySelectorAll('.featured-payment-quantity');
          paymentQuantityInputs.forEach(function(paymentInput) {
            paymentInput.value = quantity - 1;
          });
        }
      }
    });
  });

  // Handle quantity increase
  const increaseButtons = document.querySelectorAll('.featured-quantity-increase');
  increaseButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const quantityId = this.getAttribute('data-quantity-id');
      const input = document.getElementById(quantityId);
      if (input) {
        let quantity = parseInt(input.value, 10);
        input.value = quantity + 1;
        
        // Update dynamic payment buttons quantity
        const paymentQuantityInputs = document.querySelectorAll('.featured-payment-quantity');
        paymentQuantityInputs.forEach(function(paymentInput) {
          paymentInput.value = quantity + 1;
        });
      }
    });
  });

  // Validate quantity inputs
  const quantityInputs = document.querySelectorAll('.featured-quantity-input');
  quantityInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (this.value < 1 || isNaN(this.value)) {
        this.value = 1;
      }
      
      // Update dynamic payment buttons quantity
      const paymentQuantityInputs = document.querySelectorAll('.featured-payment-quantity');
      paymentQuantityInputs.forEach(function(paymentInput) {
        paymentInput.value = input.value;
      });
    });

    // Also update on input (real-time)
    input.addEventListener('input', function() {
      const value = parseInt(this.value, 10);
      if (value >= 1) {
        const paymentQuantityInputs = document.querySelectorAll('.featured-payment-quantity');
        paymentQuantityInputs.forEach(function(paymentInput) {
          paymentInput.value = value;
        });
      }
    });
  });

  // Handle Buy Now button clicks
  buyNowButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      const buttonText = this.querySelector('.button-text');
      const loadingSpinner = this.querySelector('.loading-spinner');
      
      // Get quantity from quantity input if exists
      const quantityInput = document.querySelector('.featured-quantity-input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

      // Show loading state
      if (buttonText) buttonText.classList.add('d-none');
      if (loadingSpinner) loadingSpinner.classList.remove('d-none');
      button.disabled = true;

      // Add to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) {
            throw new Error(data.description || data.message || 'Error adding to cart');
          });
        }
        return response.json();
      })
      .then(function(data) {
        // Redirect to checkout
        window.location.href = '/checkout';
      })
      .catch(function(error) {
        console.error('Error with Buy Now:', error);
        alert(error.message || 'Det uppstod ett problem. Försök igen.');
        
        // Reset button state
        if (buttonText) buttonText.classList.remove('d-none');
        if (loadingSpinner) loadingSpinner.classList.add('d-none');
        button.disabled = false;
      });
    });
  });
});
